// src/lib/categoryStrips.js
import { db } from '../firebase'
import {
  collection,
  getDocs,
  query,
  where,
  limit,
} from 'firebase/firestore'
import { normalizeProduct } from './dealsShelves' // tu l'as déjà

function shuffleArray(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

/**
 * Charge des produits pour une catégorie Firestore (champ Categorie.Id)
 * puis renvoie un tableau randomisé, limité à maxProducts.
 */
// export async function fetchRandomProductsByCategory(
//   categoryId,
//   maxProducts = 12
// ) {
//   if (!categoryId) {
//     console.warn('[CategoryStrips] Pas de categoryId fourni')
//     return []
//   }

//   const colRef = collection(db, 'productsShop')

//   // ❌ plus de orderBy(createdAt) pour éviter les erreurs d’index
//   const qRef = query(
//     colRef,
//     where('Categorie.Id', '==', categoryId),
//     limit(60)
//   )

//   const snap = await getDocs(qRef)

//   const raw = snap.docs.map((d) => ({
//     id: d.id,
//     ...d.data(),
//   }))

//   console.log(
//     '[CategoryStrips] produits trouvés pour categoryId',
//     categoryId,
//     ':',
//     raw.length
//   )

//   const shuffled = shuffleArray(raw)

//   return shuffled.slice(0, maxProducts).map((p) => ({
//     ...p,
//     _norm: normalizeProduct(p),
//   }))
// }
export async function fetchRandomProductsByCategory(categoryId, maxProducts = 12) {
  if (!categoryId) {
    console.warn("[CategoryStrips] Pas de categoryId fourni");
    return [];
  }

  const colRef = collection(db, "productsShop");

  // ✅ seulement les produits validés
  const qRef = query(
    colRef,
    where("Categorie.Id", "==", categoryId),
    where("validationStatus", "==", "validated"),
    limit(60)
  );

  const snap = await getDocs(qRef);

  const raw = snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));

  console.log(
    "[CategoryStrips] produits trouvés pour categoryId",
    categoryId,
    ":",
    raw.length
  );

  const shuffled = shuffleArray(raw);

  return shuffled.slice(0, maxProducts).map((p) => ({
    ...p,
    _norm: normalizeProduct(p),
  }));
}